import { render, staticRenderFns } from "./LangSwitch.vue?vue&type=template&id=037a9850&"
import script from "./LangSwitch.vue?vue&type=script&lang=js&"
export * from "./LangSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports